import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

// 24-hour HH:MM, matching the slot times the scheduling UI emits (no seconds).
const HH_MM = /^([01]\d|2[0-3]):[0-5]\d$/;

const SelectedSlotSchema = z.object({
  date: z.iso.date(),
  startTime: z.string().regex(HH_MM),
  endTime: z.string().regex(HH_MM),
});

export const CollectHomeownerAvailabilityTaskAttemptSchema = z.object({
  type: z.literal(TaskType.COLLECT_HOMEOWNER_AVAILABILITY),
  selectedSlots: z.array(SelectedSlotSchema).max(50),
  homeownerRequestedLaterDate: z.boolean().optional(),
  laterDateContext: z.string().max(1000).optional(),
  // Free-text the rep sends to the partner thread when completing without collecting availability.
  // Kept separate from laterDateContext (the out-of-SLA reason) so the attempt history can show it directly.
  partnerNote: z.string().max(1000).optional(),
  // The attempt handler strips this ONLY for Ensite post-PTO site visits (which require an adult on
  // site). It is still collected and valid for every other flow, where it feeds the [FASTLANE] marker
  // and history badges. Optional so post-PTO attempts (stripped) and stale clients still parse.
  unattended: z.boolean().optional(),
  // Freeform survey note the rep captures for the assigned partner. On completion it's upserted into the
  // SITE_VISIT project's productionNotes, which every partner site-visit integration already reads.
  surveyNote: z.string().max(2000).optional(),
});

export type CollectHomeownerAvailabilityTaskAttempt = z.infer<typeof CollectHomeownerAvailabilityTaskAttemptSchema>;
